(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const textEls = document.querySelectorAll('.announcement-bar__text');

  textEls.forEach(textEl => {
    if (!textEl.innerHTML.includes('[countdown]')) return;

    // Remove token but keep formatting
    textEl.innerHTML = textEl.innerHTML.replace('[countdown]', '').trim();

    // Create countdown element
    const timer = document.createElement('strong');
    timer.className = 'announcement-bar__timer';
    timer.textContent = '00h:00m:00s';

    textEl.appendChild(timer);
  });

  const timers = document.querySelectorAll('.announcement-bar__timer');
  if (!timers.length) return;

  function updateCountdown() {
    const now = new Date();
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);

    const diff = midnight - now;

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    timers.forEach(t => {
      t.textContent =
        `${String(h).padStart(2, '0')}h:` +
        `${String(m).padStart(2, '0')}m:` +
        `${String(s).padStart(2, '0')}s`;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
